import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles(() => ({
  responsiveVideo: (props) => ({
    overflow: "hidden",
    paddingBottom: props.mediumType === "youtube" ? "56.25%" : 730,
    position: "relative",
    height: 0,
  }),
  videoIframe: {
    left: 0,
    top: 0,
    height: "100%",
    width: "100%",
    position: "absolute",
    border: 0,
  },
}));
